import services from './../../services/service'; // Service Class
import validator from './../../services/validator'; // Service
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
let service = new services();
let valid = new validator();

export default {
    name: 'CnproAccounts',
    data () {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            contracts: {},
            contract: {},
            contract_threads: {},
            forums: {},
            reviews: {},
            ratings: {},
            adverts: {},
            citisave: {},
            states: {},
            cities: {},
            quote: {},
            cnproParentCategories: {},
            cnproCategories: {},
            panelFlag: false,
            viewFlag: false,
            addFlag: false,
            editFlag: false,
            deleteFlag: false,
            quotePanel: false,
            viewQuotePanel: false,
            viewQuoteFlag: false,
            viewComplaints: false,
            contractsPanel:false,
            editQuoteFlag: false,
            photo: "",
            img_url: service.imageURL,
            noCnproSet: false,
            noContractSet: false,
            loading: false,
            serviceCharge: 0,
            serviceChargeInPercentage: 0,
            totalAfterServiceCharge: 0,
            uploadWorkPicture: false,
            error_here: {},
            error_count: 0
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    computed: {
       serviceChargeTotal: {
            get(){
                return  this.totalAfterServiceCharge;
            },
            set(newVal){
                this.quote.labour_cost = newVal;
            }
        }
    },
    methods: {
        //settings
        toggleMenuActions(){
            $('.toggle-menu-actions').toggle();
        },
        back(){
            this.panelFlag = false;
            this.viewComplaints = false;
            this.deleteFlag = false;
            this.viewFlag = false;
            this.editFlag = false;
            this.viewQuoteFlag = false;
            this.viewQuotePanel = false;
            this.contractsPanel = false;
            this.viewComplaints = false;
        },
        setPanel(attr,attr2) {
            this.panelFlag = true
            if(attr == "add"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }
            if(attr == "view"){
                this.addFlag = false;
                this.deleteFlag = false;
                this.viewFlag = true;
                this.editFlag = false;
                this.viewQuoteFlag = false;
                this.viewQuotePanel = false;
                this.contractsPanel = false;
                this.viewComplaints = false;
            }
            if(attr == "edit"){
                this.addFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.editFlag = true;
                this.cnpro = attr2;
            }
            if(attr == "delete"){
                this.addFlag = false;
                this.editFlag = false;
                this.viewFlag = false;
                this.deleteFlag = true;
                this.cnpro = attr2;
            }
            if(attr == "viewQuotePanel"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.contractsPanel = false;
                this.viewQuotePanel = true;
                this.contract_threads = attr2;
                this.viewComplaints = false;
            }
            if(attr == "view-contracts"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.viewQuoteFlag = false;
                this.viewQuotePanel = false;
                this.contractsPanel = true;
                this.viewComplaints = false;
            }
            if(attr == "viewQuoteFlag"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.contractsPanel = false;
                this.viewQuotePanel = false;
                this.viewQuoteFlag = true;
                this.viewComplaints = false;
            }
            if(attr == "view-compliants"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.viewFlag = false;
                this.contractsPanel = false;
                this.viewQuotePanel = false;
                this.viewQuoteFlag = false;
                this.viewComplaints = true;
            }
            
        },
        
        setQuotePanel() {
            this.panelFlag = true
            this.quotePanel = true;
            this.addFlag = false;
            this.editFlag = false;
            this.deleteFlag = false;
            this.viewFlag = false;
            this.viewQuotePanel = false;
        },
        setEditQuote() {
            this.editQuoteFlag = true;
            this.totalAfterServiceCharge = (this.contract.contract_labour_cost - (this.contract.contract_labour_cost * this.serviceCharge));
            
        },

        setContractThreadPanel(contract,thread) {
            this.panelFlag = true
            this.addFlag = false;
            this.editFlag = false;
            this.deleteFlag = false;
            this.viewFlag = false;
            this.quotePanel = false;
            this.contractsPanel = false;
            this.viewQuotePanel = true;
            this.contract = contract;
            this.contract_threads = thread;
        },

        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        
        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        
        // Get cities
        getCities(id) {
            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then((res) => {
                this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            })
        },
       
        //--//settings

        setServiceCharge(){
            service.getServiceCharge(this).then(data => {
                if(data.status == 200) {
                    this.serviceCharge = (data.body.data / 100);
                    this.serviceChargeInPercentage = data.body.data;
                   }
            }).catch((err) => {
                 //log it
                
            })
        },
        //categories
        getCnproParentCategories() {
            service.getCnproParentCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.cnproParentCategories = data.body.data;
                   }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getCnproCategories(parent) {
            //document.getElementById("loader").style.visibility = "visible";
            service.getCnproCategories(this,parent).then(data => {
                if(data.body.status == 200) {
                    this.cnproCategories = data.body.data;
                    document.getElementById("loader").style.visibility = "hidden";
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
       
        //--//categories

        //cnpros
        getCnpros() {
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getCnpros(this, user_id).then(data => {
               if(data.body.status == 200) {
                    this.cnpros = data.body.data;
                    let result = data.body.data;
                    let count = 0;
                    result.forEach(function(element) {
                        ++count;
                        if(count == 1){
                            this.cnpro = element; 
                            //this.cnpro.cnpro_parent_category = this.cnpro.cnpro_parent_category_id;
                            //populate the categores
                            this.getCnproCategories(this.cnpro.cnpro_parent_category); //populate the categores
                            this.getCities(this.cnpro.cnpro_state); //populate the state
                        }
                    }, this);
                }else{
                    this.noCnproSet = true;
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        getCnpro(cnpro) {
            this.viewFlag = true;
            this.panelFlag = true;
            this.contractsPanel = false;
            this.addFlag = false;
            service.getCnpro(this, cnpro).then(data => {
                if(data.body.status == 200) {
                    this.cnpro = data.body.data;
                    //this.cnpro.cnpro_parent_category = this.cnpro.cnpro_parent_category_id;
                    
                    this.getCnproCategories(this.cnpro.cnpro_parent_category); //populate the categores
                    this.getCities(this.cnpro.cnpro_state); //populate the city
                 }
                   
            }).catch((err) => {
                if(err) {
                   // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })

          
        },
       
        addCnpro() {
            this.error_count = 0;
            var credentials = {
                cnpro_user: this.user.user_id,
                cnpro_category: this.cnpro.category,
                cnpro_name: this.cnpro.name,
                cnpro_email: this.cnpro.email,
                cnpro_phone: this.cnpro.phone,
                cnpro_address: this.cnpro.address,
                cnpro_state:  15,//this.cnpro.state,
                cnpro_city: 1,//this.cnpro.city,
                cnpro_description: this.cnpro.description,
                cnpro_facebook: this.cnpro.facebook || 'https://web.facebook.com/',
                cnpro_twitter: this.cnpro.twitter || 'https://twitter.com/',
                cnpro_instagram: this.cnpro.instagram || 'https://www.instagram.com/',
            }

            let navi = this.$router;
            if(credentials.cnpro_user != null && credentials.cnpro_name != null && credentials.cnpro_category != null && credentials.cnpro_city != null && credentials.cnpro_phone != null && credentials.cnpro_email != null && credentials.cnpro_address != null) {
                //validate
                if(!(valid.validateEmail(credentials.cnpro_email))){
                    this.error_here.email = "Invalid Email";
                    //this.error_here.phone = "Coming soon";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not Valid', 'Warning!');
                }
                if(!(valid.validateName(credentials.cnpro_name))){
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Name is not valid', 'Warning!');
                }
                if(!(valid.validatePhoneNumber(credentials.cnpro_phone))){
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                 }

                else if(this.error_count == 0){
                    service.addCnpro(this, credentials).then(data => {
                        if(data.body.status == 201) {
                            toastr.success("CNpro Added!", "Success!");
                            location.reload(true);
                        }else {
                            toastr.error('Sorry, could not add Cnpro', 'Warning!');
                        }
                    }).catch((err) => {
                        if(err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    })
                }else{
                    //console.log('me');
                }
            }else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
        },

        editCnpro() {
            this.error_count = 0;
            if(this.cnpro.cnpro_name != '' && this.cnpro.cnpro_phone != '' && this.cnpro.cnpro_email != '' && this.cnpro.cnpro_city != 0) {
                //validate
                if(!(valid.validateEmail(this.cnpro.cnpro_email))){
                    this.error_here.email = "Invalid Email";
                    //this.error_here.phone = "Coming soon";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Email is not Valid', 'Warning!');
                }
                if(!(valid.validateName(this.cnpro.cnpro_name))){
                    this.error_here.name = "Name is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Name is not valid', 'Warning!');
                }
                if(!(valid.validatePhoneNumber(this.cnpro.cnpro_phone))){
                   // this.error_here.phone = "Phone Number is not valid";
                    this.error_count += 1;
                    this.disable_btn = false;
                    toastr.error('Phone Number is not valid', 'Warning!');
                }

                else if(this.error_count == 0){
                    service.editCnpro(this, this.cnpro, this.cnpro.cnpro_id).then(data => {
                        if(data.body.status == 200) {
                            toastr.success("Profile Updated!", "Success!");
                            location.reload(true); //vm.$forceUpdate(); -- let vm = new Vue @main.js #check
                        }else {
                            //toastr.error('Sorry, could not update Profile', 'Warning!');
                            location.reload(true);
                        }
                    }).catch((err) => {
                        if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    })
                }else {
                  // console.log("me")
                  toastr.error(' process information', 'Warning!');
                }
            }else {
                toastr.error('Complete all fields with *', 'Warning!');
            }
           
        },


        removeCnpro() {
            service.deleteCnpro(this, this.cnpro.cnpro_id).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Profile Updated!", "Success!");
                        this.cnpro.cnpro_delete_request = data.body.data;
                       // location.reload(true); 
                    }else {
                        toastr.error('Sorry, could not update Profile', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                      toastr.error('Sorry, could not process information', 'Warning!');
                    }
            })
        },

         //uploads
        onFileChange(e, data, type) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', data);
                formData.append('data_type', type);   //image or idcard
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == 'cnpros'){
                            this.cnpro.cnpro_image = data.body.data;
                        }
                        if(type == 'cnpros_id_card'){
                            this.cnpro.cnpro_id_card = data.body.data;
                        }
                        
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },
        workPicturesUpload(e, data, type) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]); 
                formData.append('data_id', data);
                formData.append('data_type', type);   //image or idcard
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == 'contract_work_image_1'){
                            this.contract.contract_work_image_1 = data.body.data;
                        }
                        if(type == 'contract_work_image_2'){
                            this.contract.contract_work_image_2 = data.body.data;
                        }
                        if(type == 'contract_work_image_3'){
                            this.contract.contract_work_image_3 = data.body.data;
                        }
                        
                    }
                  }).catch((err) => {
                    if(err) {
                       // log it
                    }
                })
            }   
            
        },
       //--//uploads

        //--//cnpros

        //contracts

        //get all cnpros contracts
        getCnproContracts(cnpro) {
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getCnproContracts(this, cnpro).then(data => {
               if(data.body.status == 200) {
                    this.contracts = data.body.data;
                 }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        setQuote(contract,cnpro) {
            var credentials = {
                contract_cnpro: cnpro,
                contract_quote: this.quote.details || 'nill',
                contract_material_details: this.quote.materials || 'nill',
                //contract_material_cost: this.quote.material_cost || 0,
                contract_labour_cost: this.quote.labour_cost || 0,
                contract_work_duration: this.quote.duration || 0
            }
            let navi = this.$router;
            if(credentials.contract_quote != null || credentials.contract_cnpro != null) {
                service.setQuote(this, contract, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Quote Set!", "Success!");
                        //this.navi.go('cnpro-accounts');
                        location.reload(true);
                    }else {
                        toastr.error('Sorry, could not set Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        editQuote(contract,cnpro) {
            var credentials = {
                contract_cnpro: cnpro,
                contract_quote: this.contract.contract_quote_description || 'nill',
                contract_material_details: this.contract.contract_material_details || 'nill',
               // contract_material_cost: this.contract.contract_material_cost || 0,
                contract_labour_cost: this.contract.contract_labour_cost || 0,
                contract_work_duration: this.contract.contract_work_duration || 0
            }
            let navi = this.$router;
            if(credentials.contract_quote != null || credentials.contract_cnpro != null) {
                service.updateQuote(this, contract, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Quote Edited!", "Success!");
                        this.editQuoteFlag = false;
                    }else {
                        toastr.error('Sorry, could not edit Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        replyQuote(contract,cnpro) {
            var credentials = {
                contract_contract: contract,
                contract_category: 1, //cnpro
                contract_user: cnpro,
                contract_reply: this.quote.message
            }
            
            let navi = this.$router;
            if(credentials.contract_reply != null || credentials.contract_user != null || credentials.contract_user != null) {
                service.replyQuote(this, contract, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Sent!", "Success!");
                        this.contract_threads = data.body.data;
                        this.quote.message = '';
                    }else {
                        toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        markWorkDone(contract,cnpro) {
            var credentials = {
                contract_contract: contract,
                contract_cnpro: cnpro
            }
            let navi = this.$router;
            if(credentials.contract_cnpro != null) {
                service.confirmContractCnpro(this, contract, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Job Confirmed!", "Success!");
                        this.contract.contract_status_id = 8;
                        this.contract.contract_status = 'Confirmed by CNpro';
                        this.uploadWorkPictures = true;
                    }else {
                        toastr.error('Sorry, could not confirm', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        
        //--//contracts
        
    },
    created: function(){
       this.preset();
       this.getStates();
       this.getCnproParentCategories();
       this.getCnpros();
       this.setServiceCharge();

    }
}


// WEBPACK FOOTER //
// ./src/components/CnproAccounts/script.js